module.exports = __webpack_public_path__ + "img/jingxuan.0fbc5e56.png";